import { Component } from 'react';
import validation from 'Helpers/Validation';
import { validator } from 'Helpers/validator';
import LoadingOverlay from 'react-loading-overlay';

export default class Replyhelp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      description: '',
      loading: false,
      filtered: [],
      showError: false,
      errorElement: '',
    };
    this.validator = validator.getInstance();
  }

  /**
   * @method validation
   * @summary validate the inputs based on validation rules
   * @param {event} event - React onBlur event
   * @return {none} undefined
   */

  validation = (e) => {
    validation(e, 'add-team-form');
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [ name ]: value });
  };

  componentDidMount() {
    const { activeEditData: { id = '' } } = this.props;
    this.setState({ id: id })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.error !== this.props.error) {
      if (this.props.error !== true && this.props.errorElement === '') {
        this.closeForm();
      }
    }
    if (prevProps.errorElement !== this.props.errorElement) {
      this.setState({ errorElement: this.props.errorElement });
    }
    if(this.state.id === '') {
      const { activeEditData: { id = '' } } = this.props;
      this.setState({ id: id })
    }
  }

  closeForm = () => {
    this.props.closeForm();
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const formId = event.target.id;
    const { id, description } = this.state;
    this.setState({ showError: false }, () => {
      if (formId && !this.validator.checkBeforeSubmit(formId) && this.state.showError !== true) {
        if(this.props.id !== 0) {
          return this.props.updateHelp( { description, id }, this.props.filterVal);
        }
      }
    });
  };  

  render() {
    const { description, errorElement, id } = this.state;
    const { formLoading, activeEditData } = this.props;
    const { firstName, lastName, email, description: message } = activeEditData;
    return (
      <>
        <div className='addadmin savehelp open'>
          <div className='overlay' onClick={ this.closeForm }></div>
          <div className='addmgnt'>
            <LoadingOverlay
              active={ formLoading }
              spinner
              styles={ {
                wrapper: {
                  width: '100%',
                  textAlign: '-webkit-center',
                },
              } }
              text='Please wait...'
            ></LoadingOverlay>
            <div className='head'>
              <h2> Reply help </h2>
            </div>
            <div className='form'>
              <form
                id='reply-help-form'
                autoComplete='off'
                onSubmit={ this.handleSubmit }
              >
                <div className='formgroup new'>
                  <label>
                    Name: <sup>{ `${ firstName } ${ lastName }` }</sup>
                  </label>
                </div>
                <div className='formgroup new'>
                  <label>
                    Email: <sup>{ email }</sup>
                  </label>
                </div>
                <div className='formgroup new'>
                  <label>
                    Message: <sup>{ message }</sup>
                  </label>
                </div><br />
                <div className='formgroup new'>
                  <label>
                    Description<sup>*</sup>
                  </label>
                  <textarea
                    className="text-area"
                    name='description'
                    value={ description }
                    data-validation={ [ 'requiredfield' ] }
                    placeholder='Enter description here!'
                    data-error='Enter description'
                    onBlur={ this.validation }
                    onChange={ this.handleChange }
                  >
                  </textarea>
                </div>
                {errorElement && (
                  <span className='errorElement'>{errorElement}</span>
                )}
                <div className='buttons'>
                  <div>
                    <button
                      type='reset'
                      onClick={ this.closeForm }
                      className='btn btn_outline'
                    >
                      Cancel
                    </button>
                    <button className='btn btn_primary'>Send</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
    );
  }
}
